module.exports = __webpack_public_path__ + "static/media/act_sverki.06701fe8.svg";